<template>
  <div
      v-show="showRoomsList"
      class="vac-rooms-container"
      :class="{
			'vac-rooms-container-full': isMobile,
			'vac-app-border-r': !isMobile
		}"
  >
    <slot name="rooms-header"/>
    <slot name="rooms-list-search">
      <rooms-search
          :loading-rooms="loadingRooms"
          :text-messages="textMessages"
          :show-search="showSearch"
          :show-add-room="showAddRoom"
          @search-room="searchRoom"
          @add-room="$emit('add-room')"
      >
        <template v-for="(idx, name) in $slots" #[name]="data">
          <slot :name="name" v-bind="data"/>
        </template>
      </rooms-search>
    </slot>

    <loader :show="loadingRooms" type="rooms">
      <template v-for="(idx, name) in $slots" #[name]="data">
        <slot :name="name" v-bind="data"/>
      </template>
    </loader>

    <div v-if="!loadingRooms" id="rooms-list" class="vac-room-list">
      <el-tabs style="height: 100%" v-model="activeName" class="demo-tabs" @tab-click="handleClick">
        <template #default>
          <el-alert v-if="shouldShowBanAlert" style="background: #FFFBE6" type="warning" closable @close="handleCloseBanAlert">
            <template #title>
              <el-icon style="color: #FAB428;vertical-align: middle;margin-right: 6px;" :size="14">
                <WarningFilled/>
              </el-icon>
              <span class="inner_alert">{{ textMessages.ROOMS_BAN_WARNING }}</span>
              <el-button link type="primary" @click="goWhatsappDoc">{{ textMessages.ROOMS_BAN_GUIDE }}</el-button>
            </template>
            <template #default>

            </template>
          </el-alert>
          <el-tab-pane label="全部" :name="allTabName">
            <div
                v-for="(fRoom, idx) in filteredRooms"
                :id="fRoom.roomId"
                :key="fRoom.roomId"
                class="vac-room-item"
                :class="{ 'vac-room-selected': selectedRoomId === fRoom.roomId, 'vac-room-item-disabled': !isDisplayableRoom(fRoom) }"
                :style="idx === filteredRooms.length - 1 ? { marginBottom: '50px' } : null"
                @click="handleRoomItemClick(fRoom)"
            >
              <room-content
                  :current-user-id="currentUserId"
                  :room="fRoom"
                  :text-formatting="textFormatting"
                  :link-options="linkOptions"
                  :text-messages="textMessages"
                  :room-actions="roomActions"
                  @room-action-handler="$emit('room-action-handler', $event)"
                  @room-menu-open="$emit('room-menu-open', $event)"
              >
                <template v-for="(idx, name) in $slots" #[name]="data">
                  <slot :name="name" v-bind="data"/>
                </template>
              </room-content>
            </div>
            <transition name="vac-fade-message">
              <div v-if="rooms.length && !loadingRooms" id="infinite-loader-rooms">
                <div style="height: 1px;"></div>
              </div>
            </transition>
            <div v-if="!loadingRooms && !rooms.length" class="vac-rooms-empty">
              <slot name="rooms-empty">
                {{ textMessages.ROOMS_EMPTY }}
              </slot>
            </div>
          </el-tab-pane>
          <el-tab-pane
              v-for="label in labels"
              :key="label.id"
              :label="label.name"
              :name="Number(label.id)"
          >
            <loader :show="!!labelRoomsLoadingById[String(label.id)]" type="rooms">
              <template v-for="(idx, name) in $slots" #[name]="data">
                <slot :name="name" v-bind="data"/>
              </template>
            </loader>

            <div v-if="!labelRoomsLoadingById[String(label.id)]">
              <div
                  v-for="(lRoom, idx) in (activeName === Number(label.id) ? filteredLabelRooms : [])"
                  :id="lRoom.roomId"
                  :key="lRoom.roomId"
                  class="vac-room-item"
                  :class="{ 'vac-room-selected': selectedRoomId === lRoom.roomId, 'vac-room-item-disabled': !isDisplayableRoom(lRoom) }"
                  :style="idx === filteredLabelRooms.length - 1 ? { marginBottom: '50px' } : null"
                  @click="handleRoomItemClick(lRoom)"
              >
                <room-content
                    :current-user-id="currentUserId"
                    :room="lRoom"
                    :text-formatting="textFormatting"
                    :link-options="linkOptions"
                    :text-messages="textMessages"
                    :room-actions="roomActions"
                    @room-action-handler="$emit('room-action-handler', $event)"
                    @room-menu-open="$emit('room-menu-open', $event)"
                >
                  <template v-for="(idx, name) in $slots" #[name]="data">
                    <slot :name="name" v-bind="data"/>
                  </template>
                </room-content>
              </div>

              <div
                  v-if="activeName === Number(label.id) && !labelRoomsLoadingById[String(label.id)] && !activeLabelRooms.length"
                  class="vac-rooms-empty"
              >
                <slot name="rooms-empty">
                  {{ textMessages.ROOMS_EMPTY }}
                </slot>
              </div>
            </div>
          </el-tab-pane>
        </template>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Loader from '@/modules/whatsapp/components/Loader/Loader.vue'

import RoomsSearch from './RoomsSearch/RoomsSearch.vue'
import RoomContent from './RoomContent/RoomContent.vue'

import filteredItems from '@/modules/whatsapp/utils/filter-items'
import {getAllGroup, getAllLabel, getMessageByLabelId, getUsByLid} from '@/api/whatsapp'
import { Storage } from '@/utils/storage'
import { debounce } from 'lodash'

export default {
  name: 'RoomsList',
  components: {
    Loader,
    RoomsSearch,
    RoomContent
  },

  mounted() {
    this.fetchLabels()
    this.attachRoomsResizeListener()
  },

  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
    this.detachRoomsScrollListener()
    this.detachRoomsResizeListener()
  },

  props: {
    currentUserId: {type: [String, Number], required: true},
    textMessages: {type: Object, required: true},
    showRoomsList: {type: Boolean, required: true},
    showSearch: {type: Boolean, required: true},
    showAddRoom: {type: Boolean, required: true},
    textFormatting: {type: Object, required: true},
    linkOptions: {type: Object, required: true},
    isMobile: {type: Boolean, required: true},
    rooms: {type: Array, required: true},
    loadingRooms: {type: Boolean, required: true},
    roomsLoaded: {type: Boolean, required: true},
    room: {type: Object, required: true},
    customSearchRoomEnabled: {type: [Boolean, String], default: false},
    roomActions: {type: Array, required: true},
    scrollDistance: {type: Number, required: true},
    minimumVisibleRooms: {type: Number, default: 10}
  },

  emits: [
    'add-room',
    'search-room',
    'room-action-handler',
    'room-menu-open',
    'loading-more-rooms',
    'fetch-room',
    'fetch-more-rooms'
  ],

  data() {
    return {
      filter: null,
      observer: null,
      roomsScrollEls: [],
      roomsScrollHandler: null,
      userHasScrolledRooms: false,
      roomsResizeObserver: null,
      roomsResizeTimer: null,
      roomsWindowResizeHandler: null,
      showLoader: true,
      loadingMoreRooms: false,
      selectedRoomId: '',
      allTabName: 999,
      activeName: 999,

      labels: [],
      labelsLoading: false,

      labelRoomsById: {},
      labelRoomsLoadingById: {},

      groupRooms: [],
      groupLoading: false,
      groupLoaded: false,
      groupShowLoader: true,
      groupLoadingMore: false,
      groupPagination: {
        exclude: '',
        limit: 15,
        offset: 1,
        sortBy: '',
        sortOrder: ''
      },

      banAlertClosed: false
    }
  },

  computed: {
    banAlertStorageKey() {
      const d = new Date()
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `wa_rooms_ban_alert_closed_${y}${m}${day}`
    },
    shouldShowBanAlert() {
      if (this.banAlertClosed) return false
      try {
        return !Storage.get(this.banAlertStorageKey)
      } catch (e) {
        return true
      }
    },
    roomsIndexByRoomId() {
      const allRooms = Array.isArray(this.rooms) ? this.rooms : []
      const index = new Map()
      allRooms.forEach((r) => {
        const key = String(r?.roomId || '').trim()
        if (!key) return
        if (!index.has(key)) index.set(key, r)
      })
      return index
    },
    activeLabelRooms() {
      if (this.activeName === this.allTabName) return []
      const key = String(this.activeName)
      const val = this.labelRoomsById?.[key]
      const list = Array.isArray(val) ? val : []
      // Prefer the canonical room objects from "全部"列表（props.rooms），
      // so contactInfo / 归档状态 / header 等上下文保持一致。
      return list.map((r) => {
        const rid = String(r?.roomId || '').trim()
        if (!rid) return r
        return this.roomsIndexByRoomId.get(rid) || r
      })
    },
    filteredLabelRooms() {
      const base = this.customSearchRoomEnabled
          ? (this.activeLabelRooms || [])
          : filteredItems(this.activeLabelRooms || [], 'roomName', this.filter)
      return (base || []).filter((r) => !(r && r.isTemp))
    },
    filteredRooms() {
      const base = this.customSearchRoomEnabled
          ? (this.rooms || [])
          : filteredItems(this.rooms || [], 'roomName', this.filter)
      // 临时 room 仅用于右侧对话框展示，不应出现在 room-list
      return (base || []).filter((r) => !(r && r.isTemp))
    },
    filteredGroupRooms() {
      if (!this.groupRooms || !this.groupRooms.length) return []
      const base = this.customSearchRoomEnabled
          ? (this.groupRooms || [])
          : filteredItems(this.groupRooms || [], 'roomName', this.filter)
      return (base || []).filter((r) => !(r && r.isTemp))
    }
  },

  watch: {
    rooms: {
      deep: true,
      handler(newVal = [], oldVal = []) {
        const newLength = Array.isArray(newVal) ? newVal.length : 0
        const oldLength = Array.isArray(oldVal) ? oldVal.length : 0

        if (newVal !== oldVal) {
          this.loadingMoreRooms = false
        }

        // Stop "loading more" when the rooms array changes size,
        // or when we've been told all rooms are loaded.
        if (newLength !== oldLength || this.roomsLoaded) {
          this.loadingMoreRooms = false
        }

        // If all rooms are loaded, we can hide the loader and stop here.
        if (this.roomsLoaded) {
          this.showLoader = false
          return
        }
      }
    },
    groupRooms: {
      deep: true,
      handler(newVal = [], oldVal = []) {
        const newLength = Array.isArray(newVal) ? newVal.length : 0
        const oldLength = Array.isArray(oldVal) ? oldVal.length : 0

        if (newVal !== oldVal) {
          this.groupLoadingMore = false
        }

        if (newLength !== oldLength || this.groupLoaded) {
          this.groupLoadingMore = false
        }

        if (this.groupLoaded) {
          this.groupShowLoader = false
          return
        }
      }
    },
    loadingRooms(val) {
      if (!val) {
        setTimeout(() => this.initIntersectionObserver())
      }
    },
    groupLoading(val) {
      if (!val && this.activeName === 6) {
        setTimeout(() => this.initIntersectionObserver())
      }
    },
    loadingMoreRooms(val) {
      this.$emit('loading-more-rooms', val)
    },
    roomsLoaded: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadingMoreRooms = false
          if (!this.loadingRooms) {
            this.showLoader = false
          }
        }
      }
    },
    room: {
      immediate: true,
      handler(val) {
        if (!val || this.isMobile) return
        // 临时 room（创建单聊的临时对话框）不应该在 room-list 中被选中
        if (val?.isTemp) {
          this.selectedRoomId = ''
          return
        }
        this.selectedRoomId = val.roomId
      }
    }
  },

  methods: {
    attachRoomsResizeListener() {
      if (this.roomsWindowResizeHandler) return

      this.roomsWindowResizeHandler = () => {
        this.scheduleRoomsReinit()
      }

      window.addEventListener('resize', this.roomsWindowResizeHandler, { passive: true })

      // ResizeObserver handles cases where the scroll container size changes due to layout updates
      // (including browser zoom affecting computed sizes).
      if (typeof ResizeObserver !== 'undefined') {
        this.roomsResizeObserver = new ResizeObserver(() => {
          this.scheduleRoomsReinit()
        })
        try {
          if (this.$el) this.roomsResizeObserver.observe(this.$el)
        } catch (e) {
        }
      }
    },

    detachRoomsResizeListener() {
      if (this.roomsResizeTimer) {
        clearTimeout(this.roomsResizeTimer)
        this.roomsResizeTimer = null
      }

      if (this.roomsWindowResizeHandler) {
        window.removeEventListener('resize', this.roomsWindowResizeHandler)
        this.roomsWindowResizeHandler = null
      }

      if (this.roomsResizeObserver) {
        try {
          this.roomsResizeObserver.disconnect()
        } catch (e) {
        }
        this.roomsResizeObserver = null
      }
    },

    scheduleRoomsReinit() {
      if (this.roomsResizeTimer) clearTimeout(this.roomsResizeTimer)
      this.roomsResizeTimer = setTimeout(() => {
        this.roomsResizeTimer = null

        if (!this.$el) return
        if (this.loadingRooms) return
        if (!this.showRoomsList) return

        this.initIntersectionObserver()
      }, 160)
    },

    isNearRoomsBottom(target) {
      if (!target) return false
      const threshold = Number(this.scrollDistance || 0)
      try {
        const remaining = target.scrollHeight - target.scrollTop - target.clientHeight
        return remaining <= threshold
      } catch (e) {
        return false
      }
    },

    ensureRoomsScrollableOrLoadMore(scrollContainer) {
      if (this.activeName !== this.allTabName) return
      if (this.loadingRooms) return
      if (this.loadingMoreRooms) return
      if (this.roomsLoaded) return

      const target = scrollContainer || this.resolveRoomsScrollContainer()
      if (!target) return

      // If zoom/resize makes the list non-scrollable, the scroll event will never happen.
      // In that case, proactively fetch more until it becomes scrollable (or fully loaded).
      let isScrollable = false
      try {
        isScrollable = target.scrollHeight > target.clientHeight + 1
      } catch (e) {
        isScrollable = false
      }

      const minRooms = Number(this.minimumVisibleRooms || 0)
      const roomsLen = Array.isArray(this.rooms) ? this.rooms.length : 0

      if (!isScrollable && (minRooms <= 0 || roomsLen < minRooms)) {
        this.loadMoreRooms()
      }
    },

    handleCloseBanAlert() {
      this.banAlertClosed = true
      try {
        Storage.set(this.banAlertStorageKey, 1)
      } catch (e) {
      }
    },
    readWaJidMap() {
      const WA_JID_MAP_STORAGE_KEY = 'wa_jid_map'
      try {
        const cached = Storage.get(WA_JID_MAP_STORAGE_KEY)
        const lidToPn = cached?.lidToPn && typeof cached.lidToPn === 'object' ? cached.lidToPn : {}
        const pnToLid = cached?.pnToLid && typeof cached.pnToLid === 'object' ? cached.pnToLid : {}
        return { lidToPn, pnToLid }
      } catch (e) {
        return { lidToPn: {}, pnToLid: {} }
      }
    },
    writeWaJidMap(next) {
      const WA_JID_MAP_STORAGE_KEY = 'wa_jid_map'
      try {
        Storage.set(WA_JID_MAP_STORAGE_KEY, next || { lidToPn: {}, pnToLid: {} })
      } catch (e) {
      }
    },
    async ensurePnByLid(lid) {
      const s = String(lid || '').trim()
      if (!s || !s.endsWith('@lid')) return ''

      const map = this.readWaJidMap()
      const cachedPn = String(map?.lidToPn?.[s] || '').trim()
      if (cachedPn) return cachedPn

      if (typeof getUsByLid !== 'function') return ''
      try {
        const res = await getUsByLid({ lid: s })
        const result = res?.result || res?.data?.result || null
        const pn = String(result?.pn || '').trim()
        if (!pn) return ''

        const next = {
          lidToPn: { ...(map?.lidToPn || {}), [s]: pn },
          pnToLid: { ...(map?.pnToLid || {}), [pn]: s }
        }
        this.writeWaJidMap(next)
        return pn
      } catch (e) {
        return ''
      }
    },
    async normalizeLabelRoomsRoomId(list = []) {
      const rooms = Array.isArray(list) ? list : []
      const lids = Array.from(new Set(
        rooms
          .map((r) => String(r?.roomId || '').trim())
          .filter((id) => id.endsWith('@lid'))
      ))

      if (!lids.length) return rooms

      await Promise.all(lids.map((lid) => this.ensurePnByLid(lid)))
      const map = this.readWaJidMap()

      return rooms.map((r) => {
        const rid = String(r?.roomId || '').trim()
        if (!rid || !rid.endsWith('@lid')) return r
        const pn = String(map?.lidToPn?.[rid] || '').trim()
        if (!pn) return r
        return {
          ...(r || {}),
          roomId: this.normalizeRoomIdAny(pn, { isGroup: false })
        }
      })
    },
    resolveRoomsScrollContainer() {
      const root = this.$el
      if (!root) return null

      const activePane = root.querySelector('.el-tab-pane[aria-hidden="false"]')
      const roomsList = root.querySelector('#rooms-list')
      const vacRoomList = root.querySelector('.vac-room-list')
      const tabsContent = root.querySelector('.el-tabs__content')

      const candidates = [activePane, roomsList, vacRoomList, tabsContent].filter(Boolean)
      const firstScrollable = candidates.find((el) => {
        try {
          return el && el.scrollHeight > el.clientHeight
        } catch (e) {
          return false
        }
      })

      return firstScrollable || activePane || roomsList || vacRoomList || tabsContent || null
    },

    resolveRoomsScrollCandidates() {
      const root = this.$el
      if (!root) return []

      const activePane = root.querySelector('.el-tab-pane[aria-hidden="false"]')
      const roomsList = root.querySelector('#rooms-list')
      const vacRoomList = root.querySelector('.vac-room-list')
      const tabsContent = root.querySelector('.el-tabs__content')

      return [activePane, roomsList, vacRoomList, tabsContent].filter(Boolean)
    },
    resolveWahaAckValue(rawMessage) {
      const msg = rawMessage && typeof rawMessage === 'object' ? rawMessage : {}
      const data = msg?.data && typeof msg.data === 'object'
        ? msg.data
        : (msg?._data && typeof msg._data === 'object' ? msg._data : {})

      const candidates = [
        msg?.ack,
        data?.ack,
        data?.status,
        data?.info?.status,
        msg?.status
      ]
        .map((v) => (typeof v === 'string' && v.trim() !== '' ? Number(v) : v))
        .filter((v) => typeof v === 'number' && Number.isFinite(v))

      if (!candidates.length) return null
      return Math.max(...candidates)
    },
    isDisplayableRoom(room) {
      const rawId = room?.roomId
      const s = String(rawId || '').trim()
      if (!s) return false
      if (s === 'status@broadcast') return false

      const isGroup = room?.isGroup === true || room?.type === 'group'
      if (isGroup) {
        return s.includes('@g.us')
      }

      if (s.endsWith('@c.us') || s.endsWith('@lid')) return true
      if (/^\d+$/.test(s)) return true
      if (s.includes('@')) return false
      return true
    },
    handleRoomItemClick(room) {
      if (!this.isDisplayableRoom(room)) return
      this.openRoom(room)
    },
    normalizeFromUsId(value) {
      const s = String(value || '').trim()
      if (!s) return ''
      if (s.endsWith('@c.us')) return s
      const m = s.match(/^(\d+)/)
      if (m && m[1]) return `${m[1]}@c.us`
      return s
    },
    goWhatsappDoc() {
      const route = this.$router.resolve({ name: 'WhatsappDoc' })
      const href = route?.href || ''
      if (!href) return
      window.open(href, '_blank')
    },
    resolveAvatarFromRaw(raw) {
      const r = raw || {}
      const v = r?.picture || r?.avatar || r?.picUrl || r?.avatarUrl || r?.profilePicUrl || ''
      if (typeof v !== 'string') return ''
      const s = v.trim()
      if (!s) return ''
      return s
    },
    normalizeUser(user) {
      const u = user && typeof user === 'object' ? user : {}
      const avatar = this.resolveAvatarFromRaw(u)
      return {
        ...u,
        avatar
      }
    },
    normalizeRoomIdAny(val, { isGroup } = {}) {
      const s = String(val || '').trim()
      if (!s) return ''
      if (typeof isGroup === 'boolean') {
        if (isGroup) {
          if (s.includes('@g.us')) return s
          if (s.includes('@')) return s
          if (/^\d+$/.test(s)) return `${s}@g.us`
          return s
        }
        // single
        if (s.includes('@')) return s
        if (/^\d+$/.test(s)) return `${s}@c.us`
        return s
      }

      // infer
      if (s.includes('@g.us')) return s
      if (s.includes('@')) return s
      if (/^\d+$/.test(s)) return `${s}@c.us`
      return s
    },
    normalizeGetAllLabelPayload(res) {
      const payload = res?.result || res?.data?.result || res?.data || res
      if (Array.isArray(payload)) return payload
      if (Array.isArray(payload?.list)) return payload.list
      if (Array.isArray(payload?.rows)) return payload.rows
      if (Array.isArray(payload?.data)) return payload.data
      return []
    },
    fetchLabels() {
      if (this.labelsLoading) return Promise.resolve()
      this.labelsLoading = true
      return getAllLabel({})
          .then((res) => {
            const list = this.normalizeGetAllLabelPayload(res)
            const normalized = (list || [])
                .map((it) => ({
                  id: it?.id,
                  name: it?.name,
                  color: it?.color,
                  colorHex: it?.colorHex
                }))
                .filter((it) => it && it.id != null && String(it.name || '').trim() !== '' && String(it.name).trim() !== '全部')
            this.labels = normalized
          })
          .catch((e) => {
            try {
              window.dispatchEvent(new CustomEvent('wa-service-unavailable', {
                detail: {
                  source: 'getAllLabel',
                  message: e?.message || '标签列表加载失败'
                }
              }))
            } catch (err) {
            }
            throw e
          })
          .finally(() => {
            this.labelsLoading = false
          })
    },
    normalizeGetMessageByLabelIdPayload(res) {
      const payload = res?.result || res?.data?.result || res?.data || res
      if (Array.isArray(payload)) return payload
      if (Array.isArray(payload?.list)) return payload.list
      if (Array.isArray(payload?.rows)) return payload.rows
      if (Array.isArray(payload?.data)) return payload.data
      return []
    },
    mapLabelItemToRoom(item) {
      const raw = item || {}

      const last = raw?.lastMessage || raw?.last || raw?.lastMsg || null
      const lastData = last?.data || {}

      const pickFirst = (...vals) => {
        for (const v of vals) {
          const s = String(v || '').trim()
          if (s) return s
        }
        return ''
      }

      const pickFirstMatch = (predicate, ...vals) => {
        for (const v of vals) {
          const s = String(v || '').trim()
          if (!s) continue
          if (predicate(s)) return s
        }
        return ''
      }

      const WA_JID_MAP_STORAGE_KEY = 'wa_jid_map'
      const resolvePnByLidCached = (lid) => {
        const s = String(lid || '').trim()
        if (!s || !s.endsWith('@lid')) return ''
        try {
          const cached = Storage.get(WA_JID_MAP_STORAGE_KEY)
          const pn = cached?.lidToPn?.[s]
          return typeof pn === 'string' ? String(pn || '').trim() : ''
        } catch (e) {
          return ''
        }
      }

      // getMessageByLabelId 的返回结构与 getAllMessage 类似，但 roomId 常在 lastMessage.from / lastMessage.data.id.remote
      // 群聊必须使用 xxx@g.us；单聊可使用 xxx@c.us 或 xxx@lid。
      const baseRoomIdCandidate = pickFirst(
        raw?.roomId,
        raw?.chatId,
        raw?._serialized,
        raw?.id?._serialized,
        raw?.id,
        raw?._id,
        raw?.remote,
        raw?.remoteJid
      )

      // For group chats, roomId/chatId must be the group jid (xxx@g.us). Some label APIs only include it in lastMessage.*
      const groupCandidate = pickFirstMatch(
        (s) => s.includes('@g.us'),
        baseRoomIdCandidate,
        lastData?.id?.remote,
        last?.to,
        lastData?.to?._serialized,
        lastData?.to?.remote,
        last?.from
      )

      const isGroup = !!(
        raw?.isGroup === true ||
        raw?.type === 'group' ||
        raw?.groupMetadata ||
        String(baseRoomIdCandidate || '').includes('@g.us') ||
        String(groupCandidate || '').includes('@g.us')
      )

      const singleCandidate = pickFirst(
        baseRoomIdCandidate,
        last?.from,
        lastData?.from?._serialized,
        lastData?.id?.remote,
        last?.to,
        lastData?.to?._serialized
      )

      const roomIdCandidate = isGroup ? groupCandidate : singleCandidate

      let roomId = this.normalizeRoomIdAny(roomIdCandidate, { isGroup })
      if (!isGroup && typeof roomId === 'string' && roomId.endsWith('@lid')) {
        const pn = resolvePnByLidCached(roomId)
        if (pn) {
          roomId = this.normalizeRoomIdAny(pn, { isGroup: false })
        }
      }

      // Keep consistent with "全部" tab mapping (Home.vue mapChatItemToRoom)
      const normalizeWaId = (v) => {
        const s = String(v || '').trim()
        if (!s) return ''
        if (s.includes('@g.us')) return ''
        return s.replace(/@.*$/, '')
      }

      const roomName = (() => {
        const n = String(raw?.roomName || raw?.name || '').trim()
        if (n) return n
        const subject = String(raw?.groupMetadata?.subject || raw?.subject || raw?.title || '').trim()
        if (subject) return subject
        const notify = String(lastData?.notifyName || '').trim()
        if (notify) return notify
        const normalized = normalizeWaId(roomId)
        return normalized || roomId
      })()

      const safeRoomName = String(roomName || roomId || '')

      const fallbackUsers = [
        {_id: this.currentUserId, username: '我'},
        {_id: roomId, username: safeRoomName}
      ]

      const safeUsers = Array.isArray(raw?.users)
        ? raw.users.map((u) => this.normalizeUser(u))
        : fallbackUsers

      const lastBody =
          last?.body ??
          last?.content ??
          last?.text ??
          raw?.body ??
          raw?.lastMessageText ??
          null

      const tsSeconds =
          last?.timestamp ||
          raw?.conversationTimestamp ||
          raw?.timestamp ||
          raw?.t ||
          lastData?.t
      const tsMs = typeof tsSeconds === 'number'
          ? (tsSeconds > 1e12 ? tsSeconds : tsSeconds * 1000)
          : Date.now()

      const ack = this.resolveWahaAckValue(last)
      const distributed = typeof ack === 'number' ? ack >= 2 : false
      const seen = typeof ack === 'number' ? ack >= 3 : false

      const lastMessageId =
          lastData?.id?._serialized ||
          lastData?.id?.id ||
          last?.id?._serialized ||
          last?.id ||
          raw?.lastMessageId ||
          `msg_${roomId}_${tsMs}`

      const hasLastBody = lastBody !== null && lastBody !== undefined && String(lastBody).trim() !== ''
      const lastMessage = hasLastBody
          ? {
            _id: lastMessageId,
            content: String(lastBody || ''),
            senderId: last?.fromMe ? this.currentUserId : (last?.from || roomId),
            timestamp: tsMs,
            saved: typeof ack === 'number' ? ack >= 1 : true,
            distributed,
            seen,
            deleted: false
          }
          : null

      return {
        roomId,
        roomName: safeRoomName,
        avatar: this.resolveAvatarFromRaw(raw),
        unreadCount: raw?.unreadCount || 0,
        type: isGroup ? 'group' : 'single',
        isGroup: !!isGroup,
        lastMessage,
        users: safeUsers,
        location: raw?.location || '',
        workingHours: raw?.workingHours || '',
        isPinned: !!raw?.pinned,
        isSpecial: !!raw?.isSpecial,
        index: raw?.index || tsMs,
        raw
      }
    },
    fetchRoomsByLabelId(labelId, {force = false} = {}) {
      const key = String(labelId)
      if (!key) return Promise.resolve()

      if (!force && Array.isArray(this.labelRoomsById?.[key])) {
        return Promise.resolve()
      }

      if (this.labelRoomsLoadingById?.[key]) {
        return Promise.resolve()
      }

      this.labelRoomsLoadingById = { ...(this.labelRoomsLoadingById || {}), [key]: true }
      return getMessageByLabelId({ labelId: key, from: this.normalizeFromUsId(this.currentUserId) })
          .then((res) => {
            const list = this.normalizeGetMessageByLabelIdPayload(res)
            const mapped = (Array.isArray(list) ? list : [])
              .map((it) => this.mapLabelItemToRoom(it))
              .filter((r) => {
                if (!r || !r.roomId) return false
                if (typeof r.roomName !== 'string') return false
                if (!Array.isArray(r.users)) return false
                return true
              })

            // Keep mapping consistent with "全部" tab: merge with existing rooms by roomId
            const allRooms = Array.isArray(this.rooms) ? this.rooms : []
            const allIndex = new Map(allRooms.map((r) => [String(r?.roomId || ''), r]))

            const merged = mapped.map((r) => {
              const base = allIndex.get(String(r.roomId))
              if (!base) return r

              const prefer = (a, b) => {
                const sa = typeof a === 'string' ? a.trim() : ''
                if (sa) return a
                const sb = typeof b === 'string' ? b.trim() : ''
                return sb ? b : a
              }

              return {
                ...base,
                ...r,
                // do not allow empty avatar from label data to wipe out avatar from all rooms
                avatar: prefer(r.avatar, base.avatar)
              }
            })

            return this.normalizeLabelRoomsRoomId(merged)
              .then((normalized) => {
                this.labelRoomsById = { ...(this.labelRoomsById || {}), [key]: normalized }
              })
          })
          .finally(() => {
            this.labelRoomsLoadingById = { ...(this.labelRoomsLoadingById || {}), [key]: false }
          })
    },
    //
    handleClick(tab) {
      const name = tab?.props?.name
      // Element Plus 会把 tab-pane 的 name 作为 string 传出来（即使模板里写的是 :name="1"）
      // 这里统一转成 number，避免 activeName 变成 string 导致后续判断失效
      const parsedName = Number(name)
      this.activeName = Number.isNaN(parsedName) ? this.activeName : parsedName

      // 切换 tab 时重置选中项，避免出现“当前选中 roomId 不在当前 tab 列表中”导致无法选中
      this.selectedRoomId = ''
      this.$emit('close-room')

      if (this.observer) {
        this.showLoader = true
        this.observer.disconnect()
        this.observer = null
      }

      this.detachRoomsScrollListener()

      // Reset infinite-scroll state when switching tabs to avoid stale loading state
      this.loadingMoreRooms = false

      if (this.activeName === this.allTabName) {
        this.showLoader = !this.roomsLoaded && !!(this.rooms && this.rooms.length)
      }

      if (this.activeName === this.allTabName && !this.loadingRooms) {
        // tab 切换时 DOM 更新是异步的，需要等 pane 渲染完成后再初始化 observer
        setTimeout(() => this.initIntersectionObserver())
      }

      if (this.activeName !== this.allTabName) {
        this.fetchRoomsByLabelId(this.activeName, { force: true })
      }

      
    },
    //
    initIntersectionObserver() {
      if (this.observer) {
        this.showLoader = true
        this.observer.disconnect()
      }

      this.detachRoomsScrollListener()

      this.$nextTick(() => {
        const candidates = this.resolveRoomsScrollCandidates()
        if (candidates.length) {
          this.attachRoomsScrollListener(candidates)
        }
      })

      if (this.activeName !== this.allTabName) {
        this.loadingMoreRooms = false
        this.showLoader = false
        this.groupLoadingMore = false
        this.groupShowLoader = false
        this.observer = null
        return
      }

      if (this.activeName === this.allTabName) {
        if (this.roomsLoaded || !(this.rooms && this.rooms.length)) {
          this.loadingMoreRooms = false
          this.showLoader = false
          this.observer = null
          return
        }
      }

      // 仅在「全部」tab 下启用无限滚动

      // Use the outer rooms list container as the authoritative scroll root.
      // Zoom/layout changes can make tab-pane become non-scrollable while #rooms-list remains the real scroller.
      const activePane = this.$el.querySelector('.el-tab-pane[aria-hidden="false"]')
      const roomsList = this.$el.querySelector('#rooms-list')
      const scrollContainer = roomsList || this.resolveRoomsScrollContainer() || activePane
      const loaderSelector = '#infinite-loader-rooms'
      const loader = activePane?.querySelector(loaderSelector)

      // Attach listeners to stable candidates to avoid missing the real scroller after zoom.
      const candidates = this.resolveRoomsScrollCandidates()
      if (candidates.length) {
        this.attachRoomsScrollListener(candidates)
      } else if (scrollContainer) {
        this.attachRoomsScrollListener([scrollContainer])
      }

      if (scrollContainer) {
        this.ensureRoomsScrollableOrLoadMore(scrollContainer)
      }

      if (loader && scrollContainer) {
        const options = {
          root: scrollContainer,
          rootMargin: `${this.scrollDistance}px`,
          threshold: 0
        }

        this.observer = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting) {
            // Avoid auto pagination on initial render; only paginate after user actually scrolls.
            if (this.userHasScrolledRooms || this.isNearRoomsBottom(scrollContainer)) {
              this.loadMoreRooms()
            }
          }
        }, options)

        this.observer.observe(loader)
      } else {
        // If there is no loader element (e.g. list empty), ensure we don't show loading state
        if (this.activeName === this.allTabName) {
          this.loadingMoreRooms = false
          this.showLoader = false
        }
      }
    },

    attachRoomsScrollListener(el) {
      const els = Array.isArray(el) ? el : [el]
      const normalized = els.filter(Boolean)
      if (!normalized.length) return

      this.roomsScrollEls = normalized

      if (!this.roomsScrollHandler) {
        this.roomsScrollHandler = (evt) => {
          if (this.activeName !== this.allTabName) return
          if (this.loadingRooms) return
          if (this.loadingMoreRooms) return
          if (this.roomsLoaded) return

          // Mark that the user has interacted with the scroll container.
          // We only allow pagination after a real scroll event happens.
          if (evt && evt.type === 'scroll') {
            this.userHasScrolledRooms = true
          }

          const threshold = Number(this.scrollDistance || 0)
          const targets = Array.isArray(this.roomsScrollEls) ? this.roomsScrollEls : []
          for (const target of targets) {
            if (!target) continue
            const remaining = target.scrollHeight - target.scrollTop - target.clientHeight
            if (remaining <= threshold) {
              this.loadMoreRooms()
              break
            }
          }
        }
      }

      normalized.forEach((node) => {
        node.removeEventListener('scroll', this.roomsScrollHandler)
        node.addEventListener('scroll', this.roomsScrollHandler, { passive: true })
      })
    },

    detachRoomsScrollListener() {
      const nodes = Array.isArray(this.roomsScrollEls) ? this.roomsScrollEls : []
      if (nodes.length && this.roomsScrollHandler) {
        nodes.forEach((node) => {
          if (!node) return
          node.removeEventListener('scroll', this.roomsScrollHandler)
        })
      }
      this.roomsScrollEls = []
    },
    searchRoom(ev) {
      this.filter = ev.target.value

      if (this.customSearchRoomEnabled) {
        this.$emit('search-room', this.filter)
      }
    },
    openRoom(room) {
      const currentRoomId = this.room && this.room.roomId

      const normalizeRoomId = (val) => {
        const s = String(val || '').trim()
        if (!s) return ''
        // 群聊必须是 @g.us，否则会导致拉历史用错 chatId
        if (room?.isGroup === true || room?.type === 'group' || (typeof s === 'string' && s.includes('@g.us'))) {
          if (s.includes('@g.us')) return s
          if (s.includes('@')) return s
          if (/^\d+$/.test(s)) return `${s}@g.us`
          return s
        }
        return s
      }

      if (room.roomId === currentRoomId) {
        this.selectedRoomId = ''
        this.$emit('close-room')
        return
      }

      if (!this.isMobile) this.selectedRoomId = room.roomId

      const normalizedRoom = {
        ...(room || {}),
        roomId: normalizeRoomId(room?.roomId)
      }

      this.$emit('fetch-room', {room: normalizedRoom})
    },
    loadMoreRooms() {
      if (this.loadingMoreRooms) return

      if (this.roomsLoaded) {
        this.loadingMoreRooms = false
        this.showLoader = false
        return
      }

      this.$emit('fetch-more-rooms')
      this.loadingMoreRooms = true
    },
    ensureGroupRoomsLoaded() {
      if (this.groupLoading) return
      if (this.groupRooms && this.groupRooms.length) return
      if (this.groupLoaded) return
      return this.loadGroups(false)
    },
    normalizeGetAllGroupPayload(res) {
      const payload = res?.result || res?.data?.result || res?.data || res
      if (Array.isArray(payload)) return payload
      if (Array.isArray(payload?.list)) return payload.list
      if (Array.isArray(payload?.rows)) return payload.rows
      if (Array.isArray(payload?.data)) return payload.data
      return []
    },
    mapGroupItemToRoom(item) {
      const raw = item || {}
      const normalizeGroupId = (val) => {
        const s = String(val || '').trim()
        if (!s) return ''
        if (s.includes('@g.us')) return s
        if (s.includes('@')) return s
        // 纯数字的群 id，统一补齐 @g.us
        if (/^\d+$/.test(s)) return `${s}@g.us`
        return s
      }

      // 群聊 roomId 必须是群的 remoteJid（xxx@g.us）。
      // 注意：消息里的 to 可能是我自己的 c.us/lid（尤其是历史同步消息），不能用来当群 id。
      const roomId = normalizeGroupId(
          raw?._serialized ||
          raw?.roomId ||
          raw?.chatId ||
          raw?.groupId ||
          raw?.jid ||
          raw?.id?._serialized ||
          raw?.id ||
          raw?._id ||
          raw?.remote?._serialized ||
          raw?.remote ||
          raw?._data?.id?.remote ||
          raw?._data?.to?._serialized ||
          raw?._data?.to?.remote ||
          ''
      )

      const roomName = raw?.roomName || raw?.name || raw?.subject || raw?.title || roomId

      const last = raw?.lastMessage || raw?.last || raw?.lastMsg || null
      const lastBody = last?.body || last?.content || last?.text || raw?.lastMessageText || ''
      const tsSeconds = last?.timestamp || raw?.timestamp || raw?.t
      const tsMs = typeof tsSeconds === 'number' ? (tsSeconds > 1e12 ? tsSeconds : tsSeconds * 1000) : Date.now()

      const lastMessage = lastBody
          ? {
            _id: last?.id?._serialized || last?.id || raw?.lastMessageId || `msg_${roomId}_${tsMs}`,
            content: lastBody,
            senderId: last?.from || roomId,
            timestamp: tsMs,
            saved: true,
            distributed: true,
            seen: true,
            deleted: false
          }
          : null

      return {
        roomId,
        roomName,
        avatar: this.resolveAvatarFromRaw(raw),
        unreadCount: raw?.unreadCount || 0,
        type: 'group',
        isGroup: true,
        lastMessage,
        users: [
          {_id: this.currentUserId, username: '我'},
          {_id: roomId, username: roomName}
        ],
        location: '',
        workingHours: '',
        isPinned: !!raw?.pinned,
        isSpecial: false,
        index: tsMs,
        raw
      }
    },
    loadGroups(merge = false) {
      if (!merge) {
        this.groupPagination.offset = 1
        this.groupLoaded = false
      }

      if (merge && this.groupLoaded) {
        return Promise.resolve()
      }

      this.groupLoading = !merge
      this.groupLoadingMore = merge

      const params = {
        exclude: this.groupPagination.exclude,
        limit: this.groupPagination.limit,
        offset: this.groupPagination.offset,
        sortBy: this.groupPagination.sortBy,
        sortOrder: this.groupPagination.sortOrder
      }

      return getAllGroup(params)
          .then((res) => {
            const list = this.normalizeGetAllGroupPayload(res)
            const mapped = (list || [])
                .map((it) => this.mapGroupItemToRoom(it))
                .filter((r) => r.roomId)
            
            const hasMore = mapped.length === this.groupPagination.limit
            this.groupLoaded = !hasMore

            if (merge) {
              const existingIds = new Set(this.groupRooms.map(r => r.roomId))
              const newRooms = mapped.filter(r => !existingIds.has(r.roomId))
              this.groupRooms = [...this.groupRooms, ...newRooms]
            } else {
              this.groupRooms = mapped
            }

            if (hasMore) {
              this.groupPagination.offset += 1
            }
          })
          .finally(() => {
            this.groupLoading = false
            this.groupLoadingMore = false
            this.groupShowLoader = !this.groupLoaded
          })
    },
    loadMoreGroups() {
      if (this.groupLoadingMore || this.groupLoaded) return
      this.groupLoadingMore = true
      this.loadGroups(true)
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.el-tabs__nav-wrap:after) {
  background: none !important;
}

:deep(.el-tabs__header) {
  margin: 0px !important;
}

:deep(.el-tabs__content) {
  flex: 1 !important;
  min-height: 0 !important;
}

:deep(.el-tab-pane) {
  height: 100% !important;
  overflow-y: auto !important;
}

.inner_alert {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #45525C;
}

:deep(.el-alert--warning) {
  height: max-content !important;
}

:deep(.demo-tabs) {
  height: 100% !important;
}

:deep(.el-alert__content) {
  gap: normal !important;
}

.vac-room-item-disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

:deep(.el-tabs__content){
  margin-top: 6px !important;
}
</style>
